
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"8","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.226 9.56a1 1 0 101.414 1.414L1.226 9.56zM6.2 6l.707.707a1 1 0 000-1.414L6.2 6zM2.64 1.026a1 1 0 00-1.414 1.415L2.64 1.026zm0 9.948l4.267-4.267-1.414-1.414L1.226 9.56l1.414 1.414zm4.267-5.681L2.64 1.026 1.226 2.441l4.267 4.266 1.414-1.414z","fill":"#072521"}})])
      }
    
      }
    